export const emptyAccountingProgress = () => ({
    categories: false,
    bank: false,
    reviewed: false,
});

export const emptyDuesProgress = () => ({
    members: false,
    dues: false,
    payouts: false,
    billing: false,
});

export function isAccountingProgressComplete(progress = {}) {
    return !!(progress.categories && progress.bank && progress.reviewed);
}

export function isDuesProgressComplete(progress = {}) {
    return !!(progress.members && progress.dues && progress.payouts && progress.billing);
}

export function goalSelectionUpdate(goal) {
    return { goal, dismissed: false };
}
